import { themeColors } from "../../../../themeColors";
/**
 * @file   src\mobile\components\Onboarding\AgentProfile.js
 * @brief  This file is responsible for adding agent profile while onboarding.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import TextArea from "../../../../components/Common/TextArea";
import TextBox from "../../../../components/Common/TextBox";
import FldCloseIcon from "../../../images/round-close-icon.svg";
import {
  handleTextBoxChange,
  capitalizeString,
} from "../../../../actions/common";
import AddIcon from "../../../../images/v2/Add-icon.svg";
import {
  capitalizeFirstString,
  getFileType,
  toTitleCase,
  getLocalStorage,
  trimString,
  formatPhoneNumber,
  upperCaseEachSentenceFirst,
  removeLocalStorage,
} from "../../../../helpers/common";
import {
  alphaNumericValidation,
  licenseValidation,
  phoneNumberValidation,
  textValidations,
} from "../../../../helpers/validations";
import {
  AGENT_USER_FREE_PLAN,
  BIO_MAX_COUNT,
  ERROR_TEXT,
  TESTIMONIAL_MAX_COUNT,
} from "../../../../constants/common";
import { fetchUserDetails } from "../../../../actions/userprofile";
import { USER_INFO_KEY } from "../../../../constants/common";
import Loader from "../../../../components/Common/Loader";
import { getAgentDetails } from "../../../../services/agentClientsService";
import ValidationAlertIcon from "../../../images/validation-alert-icon.svg";
import SparkleBigIcon from "../../../images/sparkle-big-icon.svg";
import ProfImgPlaceholder from "../../../images/prof-img-placeholder.svg";
import ProfileImageCropper from "../ProfileImageCropper";
import { getGeoLocation } from "../../../../services/commonServices";
import useUserDetailsById from "../../../../hooks/useUserDetailsById";

const AgentProfilePremium = (props) => {
  const dispatch = useDispatch();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const userId = _.get(sessionData, "userInfo.userId", "");
  // const userDetailsFromStore = useSelector(
  //   (state) => state.userProfile.userDetails,
  // );
  // const [userDetails, setUserDetails] = useState(null);
  const [location, setLocation] = useState("");
  const [locationError, setLocationError] = useState("");
  const locationString = getLocalStorage("LocationString");
  const [formattedAddress, setFormattedAddress] = useState();
  const [locationList, setLocationList] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFNError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLNError] = useState("");
  const [company, setCompany] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [license, setLicense] = useState("");
  const [licenseError, setLicenseError] = useState("");
  const [bio, setBio] = useState("");
  const [bioError, setBioError] = useState("");
  const [bioCount, setBioCount] = useState(0);
  const [imgError, setImgError] = useState("");
  const [reload, setReload] = useState(0);
  const supportedImageFormats = ["jpg", "jpeg", "png"];
  const { handleAgentDetailsSave } = props;
  const [isUploading, setIsUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [logoError, setLogoError] = useState("");
  const [clientTestimonial, setTestimonials] = useState([""]);
  const [testimonialCounts, setTestimonialCounts] = useState([0]);
  const [logoUrl, setLogoUrl] = useState("");
  const [facebookUrl, setFacebookUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [websiteUrlError, setWebsiteUrlError] = useState(false);
  const [youtubeUrlError, setYoutubeUrlError] = useState(false);
  const [facebookUrlError, setFacebookUrlError] = useState(false);
  const [instagramUrlError, setInstagramUrlError] = useState(false);
  const [bioCursorPos, setBioCursorPos] = useState(0);
  const bioRef = useRef();

  const userDetails = useUserDetailsById(userId, true);

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [changedImage, setChangedImage] = useState(null);
  const [showPofileImageUploadModal, setShowPofileImageUploadModal] =
    useState(false);
  const [isSquareImage, setIsSquareImage] = useState(false);

  const ShowPofileImageUploadModalClose = () =>
    setShowPofileImageUploadModal(false);
  const ShowPofileImageUploadModalShow = (isSquareImage) => {
    setIsSquareImage(isSquareImage);
    setShowPofileImageUploadModal(true);
  };

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserDetails());
    }
  }, [reload, userId]);

  // useEffect(() => {
  //   if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
  //     setUserDetails(userDetailsFromStore[userDetailsFromStore?.length - 1]);
  //   }
  // }, [userDetailsFromStore]);

  // useEffect(() => {
  //   if (userId) {
  //     getAgentInfo(userId);
  //   }
  // }, []);

  // const getAgentInfo = async (userId) => {
  //   await getAgentDetails(userId).then((response) => {
  //     if (response) {
  //       const result = _.get(response, "result[0]", null);
  //       setLocation(_.get(result, "Location", null));
  //       setCompany(_.get(result, "Company", null));
  //       setLicense(_.get(result, "LicenseNo", null));
  //       setImageUrl(_.get(result, "Img", ""));
  //       setFirstName(_.get(result, "FirstName", null));
  //       setLastName(_.get(result, "LastName", null));
  //       setBio(_.get(result, "Bio", null));
  //       setFacebookUrl(_.get(result, "facebookUrl", null));
  //       setInstagramUrl(_.get(result, "instagramUrl", null));
  //       setWebsiteUrl(_.get(result, "websiteUrl", null));
  //       setYoutubeUrl(_.get(result, "youtubeUrl", null));
  //       setLogoUrl(_.get(result, "logoUrl", ""));
  //       setTestimonials(_.get(result, "clientTestimonial", []));
  //     }
  //   });
  // };

  const getAddresseDetails = async ({ eventType, reqPayload }) => {
    await getGeoLocation(reqPayload).then((data) => {
      const results = _.get(data, "results");
      if (results?.length > 0) {
        const formatted_address = _.get(results?.[0], "formatted_address", "");
        if (results?.length > 0 && formatted_address !== "United States") {
          if (locationString) {
            handleItemSelection(results[0]);
            removeLocalStorage("LocationString");
          } else {
            setLocationList(results);
          }
        }
      }
    });
  };

  const clearAddressList = () => {
    setLocationList([]);
  };

  const handleLocationChange = (val) => {
    const value = capitalizeString(val);
    const reqPayload = `address=${value}&components=country:US`;
    if (value.trim() !== "") {
      getAddresseDetails({ reqPayload: reqPayload });
    } else {
      clearAddressList();
    }
    if (value && value.trim() !== "") {
      setLocation(value);
    } else {
      setLocation(value);
    }
  };

  const handleItemSelection = async (address) => {
    let city, state, county;
    removeLocalStorage("searchedLocation");
    const geometry = _.get(address, "geometry", "");
    const locBounds = _.get(geometry, "location", "");
    const formatted_address = _.get(address, "formatted_address", "");
    const firstAddressComponent = _.get(address, "address_components", "");
    const stateSearched = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "administrative_area_level_1";
    });
    if (stateSearched.length) {
      state = _.get(stateSearched?.[0], "short_name", "");
    }
    const locality = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "locality";
    });
    if (locality.length) {
      city = _.get(locality?.[0], "long_name", "");
    }
    const countyList = firstAddressComponent.filter(function (ca) {
      return ca.types?.[0] === "administrative_area_level_2";
    });

    if (countyList.length) {
      county = _.get(countyList?.[0], "short_name", "");
    }
    if (city != undefined) {
      setFormattedAddress(city + ", " + state);
    } else {
      setFormattedAddress(formatted_address);
    }
    setLocation(city != undefined ? city + ", " + state : formatted_address);
    clearAddressList();
  };

  const handleUrlChange = (url, type) => {
    const trimmedUrl = url?.trim() || ""; // Ensure it's a string
    const websiteUrlRegex =
      /^(https?:\/\/)?([\w\-]+\.)+[\w]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    // Allow empty value, but validate only when there is input
    const isValid = trimmedUrl === "" || websiteUrlRegex.test(trimmedUrl);

    switch (type) {
      case "facebook":
        setFacebookUrl(trimmedUrl);
        setFacebookUrlError(trimmedUrl !== "" && !isValid); // Error only if input is invalid
        break;
      case "instagram":
        setInstagramUrl(trimmedUrl);
        setInstagramUrlError(trimmedUrl !== "" && !isValid);
        break;
      case "website":
        setWebsiteUrl(trimmedUrl);
        setWebsiteUrlError(trimmedUrl !== "" && !isValid);
        break;
      default:
        break;
    }
  };

  const handleYoutubeUrl = (url) => {
    const trimmedUrl = url.trim();
    setYoutubeUrl(trimmedUrl);
    setYoutubeUrlError(
      trimmedUrl === "" ? false : !validateYoutubeUrl(trimmedUrl),
    );
  };

  const validateYoutubeUrl = (url) => {
    const youtubeRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)$/;
    return youtubeRegex.test(url);
  };

  const validatePhoneNumber = () => {
    setPhoneError("");
    if (trimString(phone) !== "") {
      if (!phoneNumberValidation(phone.trim())) {
        setPhoneError("Enter Valid Phone Number");
      } else {
        setPhone(phone);
      }
    } else {
      setPhoneError("Enter Phone Number");
      setPhone("");
    }
  };

  useEffect(() => {
    if (bioRef.current) {
      bioRef.current.setSelectionRange(bioCursorPos, bioCursorPos);
    }
  }, [bioCursorPos]);

  const handleBioChange = (e) => {
    setBioError("");
    const _bio = handleTextBoxChange(e);
    if (!textValidations(_bio)) {
      setBioError(ERROR_TEXT);
    }
    let value = capitalizeFirstString(_bio);
    value = upperCaseEachSentenceFirst(value);
    if (trimString(value) != "") {
      setBioCursorPos(e.target.selectionStart);
    }
    setBioCount(value.length);
    setBio(value);
  };

  const handleTestimonial = (e, index) => {
    const value = e.target.value;
    const updatedTestimonials = [...clientTestimonial];
    const updatedCounts = [...testimonialCounts];

    updatedTestimonials[index] = value;
    updatedCounts[index] = value.length;

    setTestimonials(updatedTestimonials);
    setTestimonialCounts(updatedCounts);
  };

  const addTestimonial = () => {
    setTestimonials([...clientTestimonial, ""]);
    setTestimonialCounts([...testimonialCounts, 0]);
  };

  const updateReloadParam = () => {
    setReload(reload + 1);
  };

  const handleImageUpload = async (e, isLogo) => {
    const selectedFileType = getFileType(_.get(e.target.files[0], "name"));
    const file = e.target.files[0];

    setImgError("");
    let isValid = true;
    if (!_.includes(supportedImageFormats, selectedFileType)) {
      isValid = false;
      if (isLogo) setLogoError("Select Valid Logo");
      else setImgError("Select Valid Image");
    }
    if (isValid) {
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setChangedImage(reader.result);
          ShowPofileImageUploadModalShow(isLogo);
        };
        reader.readAsDataURL(file);
        // Reset the file input
        e.target.value = null;
      }
    }
  };

  // const checkValid = () => {
  //   if (userDetails?.PlanName != AGENT_USER_FREE_PLAN) {
  //     if (location && license && company && firstName && lastName && phone) {
  //       if (
  //         locationError ||
  //         licenseError ||
  //         companyError ||
  //         firstNameError ||
  //         lastNameError ||
  //         phoneError
  //       ) {
  //         return true;
  //       }
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   } else {
  //     if (location && license && company && firstName && lastName) {
  //       if (
  //         locationError ||
  //         licenseError ||
  //         companyError ||
  //         firstNameError ||
  //         lastNameError ||
  //         websiteUrlError ||
  //         youtubeUrlError
  //       ) {
  //         return true;
  //       }
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }
  // };

  const agentInfo = {
    firstName: userDetails?.FirstName,
    lastName: userDetails?.LastName,
    company: userDetails?.Company,
    location: userDetails?.Location,
    licenseNo: userDetails?.LicenseNo,
    bio: bio,
    img: imageUrl || "",
    facebookUrl: facebookUrl,
    instagramUrl: instagramUrl,
    websiteUrl: websiteUrl,
    youtubeUrl: youtubeUrl,
    clientTestimonial: clientTestimonial,
  };

  return (
    <div className="gitcha-main-wrapper pb-0 bg-grey-variant">
      {isUploading ? <Loader /> : ""}
      <div className="content-wrapper pt-0 h-100">
        <div className="inner-layout-header-new bg-transparent d-none">
          <div className="review-plan-header w-100">
            <div className="signup-login-header-top signup-header-txt clearfix"></div>
          </div>
        </div>

        <div className="inner-layout-content-new h-100">
          <div className="welcome-premium-content">
            <h4 className="pt-5">
              Welcome to Pro! 🎉 <br />
              Level up your visibility!
            </h4>
            <div className="profile-wrap">
              <div className="profile-wrap-img">
                <figure>
                  {
                    <img
                      src={
                        imageUrl !== "" && imageUrl !== null
                          ? imageUrl + "?" + Math.random().toString(36)
                          : ProfImgPlaceholder
                      }
                    />
                  }
                </figure>
                <div className="file-upload">
                  <input
                    type="file"
                    name="profileImage"
                    id="file-3"
                    onChange={(e) => handleImageUpload(e)}
                    className="inputfile inputfile-3"
                    disabled={
                      userDetails?.PlanName !== AGENT_USER_FREE_PLAN
                        ? false
                        : true
                    }
                  />
                  <label for="file-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                    >
                      <g transform="translate(-2 -2)">
                        <path
                          d="M2,8a.5.5,0,0,1,.5-.5h11a.5.5,0,0,1,0,1H2.5A.5.5,0,0,1,2,8Z"
                          fill="#fff"
                          fillRule="evenodd"
                        />
                        <path
                          d="M8,2a.5.5,0,0,1,.5.5v11a.5.5,0,0,1-1,0V2.5A.5.5,0,0,1,8,2Z"
                          fill="#fff"
                          fillRule="evenodd"
                        />
                      </g>
                    </svg>
                  </label>
                  <span className="error-msg w-125 h-auto">{imgError}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="d-block pe-3 ps-3">
            <div className="row">
              <div className="col-12">
                <div className="mob-fld-wrap position-relative mb-0">
                  <label className="form-label">Bio (optional)</label>
                  <TextArea
                    className="form-control"
                    errorMessage={bioError}
                    maxLength={BIO_MAX_COUNT}
                    value={bio ? bio : ""}
                    placeholder="Tell other agents and prospective clients a little bit about yourself..."
                    onChange={(e) => {
                      handleBioChange(e);
                    }}
                    txtRef={bioRef}
                  />
                  <div className="des-count mb-0">
                    <span>{bioCount}</span>/<span>{BIO_MAX_COUNT}</span>
                  </div>
                </div>
              </div>

              <div className="col-6 pe-2">
                <div className="mob-fld-wrap position-relative mb-2">
                  <label className="form-label">
                    Facebook Profile (Optional)
                  </label>

                  <TextBox
                    name="facebookUrl"
                    type="text"
                    notShowError={true}
                    className={"form-control mob-pr-44"}
                    value={facebookUrl}
                    placeholder="Paste link to profile here..."
                    onChange={(e) =>
                      handleUrlChange(e.target.value, "facebook")
                    }
                    errorMessage={facebookUrlError ? "Enter Valid URl" : ""}
                  />
                </div>
              </div>
              <div className="col-6 ps-2">
                <div className="mob-fld-wrap position-relative mb-2">
                  <label className="form-label">
                    Instagram Profile (Optional)
                  </label>

                  <TextBox
                    name="instagramUrl"
                    type="text"
                    notShowError={true}
                    className={"form-control mob-pr-44"}
                    value={instagramUrl}
                    placeholder="Paste link to profile here..."
                    onChange={(e) =>
                      handleUrlChange(e.target.value, "instagram")
                    }
                    errorMessage={instagramUrlError ? "Enter Valid URl" : ""}
                  />
                </div>
              </div>

              <div className="col-6 pe-2">
                <div className="mob-fld-wrap position-relative mb-2">
                  <label className="form-label">Website</label>

                  <TextBox
                    name="websiteUrl"
                    type="text"
                    notShowError={true}
                    className={"form-control mob-pr-44"}
                    value={websiteUrl}
                    placeholder="Paste link to website here..."
                    onChange={(e) => handleUrlChange(e.target.value, "website")}
                    errorMessage={websiteUrlError ? "Enter Valid URl" : ""}
                  />
                </div>
              </div>
              <div className="col-6 ps-2">
                <div className="mob-fld-wrap position-relative mb-0">
                  <label className="form-label">Youtube Video</label>

                  <TextBox
                    name="youtubeUrl"
                    type="text"
                    notShowError={true}
                    className={"form-control mob-pr-44"}
                    value={youtubeUrl}
                    placeholder="Paste video embed link here"
                    onChange={(e) => handleYoutubeUrl(e.target.value)}
                    errorMessage={
                      youtubeUrlError ? "Enter Valid Youtube URl" : ""
                    }
                  />
                </div>
              </div>
              <div className="col-12">
                {clientTestimonial.map((testimonial, index) => (
                  <div
                    className="mob-fld-wrap position-relative mb-0"
                    key={index}
                  >
                    <label className="form-label">
                      Client testimonial (optional)
                    </label>
                    <TextArea
                      className="form-control"
                      maxLength={1000}
                      value={testimonial}
                      placeholder="What your clients think..."
                      onChange={(e) => handleTestimonial(e, index)}
                    />
                    <div className="des-count mb-0">
                      <span>{testimonialCounts[index]}</span>/
                      <span>{TESTIMONIAL_MAX_COUNT}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div
                className="d-flex align-items-center add-testimonial-btn"
                onClick={addTestimonial}
              >
                <img src={AddIcon} alt="add-icon"></img>
                <button className="add-another-testimonial">
                  Add another testimonial
                </button>
              </div>
            </div>
            <div className="btn-wrap text-center pb-4 pt-2">
              <button
                type="button"
                className="btn btn-primary w-100 mb-0"
                // disabled={checkValid()}
                onClick={() => handleAgentDetailsSave(agentInfo)}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <ProfileImageCropper
        userId={userId}
        image={changedImage}
        show={showPofileImageUploadModal}
        onHide={() => {
          ShowPofileImageUploadModalClose();
        }}
        isSquare={isSquareImage}
        updateImageAfterCrop={(imageUrl) => {
          if (isSquareImage) {
            setLogoUrl(imageUrl);
          } else {
            setImageUrl(imageUrl);
          }
          ShowPofileImageUploadModalClose();
        }}
      />
    </div>
  );
};

export default AgentProfilePremium;
